import { DocumentData } from "@king-ict/eupisi-ui/models";

import { ResolutionDocumentType } from "../../models/ProgramRequest/ResolutionDocumentType";

export interface ExecutionResolutionDocument {
  id: number;
  /** 
   * This is the rather poorly named resolution type
   * - Otključavanje zahtjeva MZO, etc.
   * It is NOT the DocumentType used for this resolution.
   */
  documentTypeId: ResolutionDocumentType;
  classificationMark: string;
  registryNumber: string;
  issueDate?: Date;
  /** This is used in Consent Decisions */
  dateFrom?: Date;
  dateTo?: Date;
  resolutionDocument?: DocumentData;
  /** This is used in the Status History */
  description?: string;
  /** This is used in Consent Decisions */
  isApproved?: boolean;
  processingDeadline?: number;
}

export function createResolutionDocument(documentTypeId: ResolutionDocumentType, classificationMark: string): ExecutionResolutionDocument {
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
  return {
    id: 0,
    documentTypeId: documentTypeId,
    classificationMark: classificationMark,
    registryNumber: "",
    issueDate: today
  }
}